// PN-6 / PN-9 (T-430) — « Où en est ce dossier, et quelle est la prochaine étape », pour la fiche.
// PN-9 : AUCUNE table propre à la fiche. La prochaine étape vient du serveur (`dossier.prochaine_etape`, servie par GET /dossiers/{id}) : c'est la
// MÊME fonction pure (`metier_hub/prochaine_etape.py`) que celle de la colonne « Prochaine action » des grilles et de la file de travail AMO.
// La fiche n'invente ni texte ni onglet : elle affiche {action, onglet, motif} et traduit seulement l'onglet du serveur en onglet de la fiche.
import { ongletFiche } from "../FileTravailAmo";

// Étapes du pipeline où le dépôt / le suivi se font sur le portail officiel ANAH (lien secondaire, étape externe assumée).
const ETAPES_PORTAIL = ["depose", "instruction"];

/** Action de la fiche (null si le serveur n'en donne pas). `ongletsVisibles` : clés des onglets affichés pour ce profil. */
export function prochaineEtapeFiche(dossier, codeEtape, ongletsVisibles = null) {
  const pe = dossier?.prochaine_etape;
  if (!pe || !pe.action || pe.etape === "aucune") return null;
  let tab = pe.onglet ? ongletFiche(pe.onglet) : null;
  // L'onglet visé peut ne pas exister pour ce profil (DAL réservé à l'AMO) : Conformité plutôt qu'un clic mort.
  if (tab && ongletsVisibles && !ongletsVisibles.includes(tab)) tab = "conformite";
  return {
    label: pe.action, tab, motif: pe.motif || "", etape: pe.etape,
    anahPortal: pe.etape === "depot_a_faire" || ETAPES_PORTAIL.includes(codeEtape),
  };
}

/** Phrase de tête : où en est le dossier et ce qui vient ensuite. T-430b : « où en est » = l'étape que le SERVEUR a utilisée pour calculer l'action
 * (`etape_pipeline_libelle`), jamais celle de la frise : sinon la phrase se contredit (frise « Créé », action « Rédiger le DAL, la visite est faite »).
 * Un serveur plus ancien (sans ce libellé) : repli sur l'étape de la frise. */
export function phraseOuEnEst(pipeline, code, abandonne, dossier) {
  if (abandonne) return "Où en est ce dossier : abandonné. Il n'y a plus d'étape suivante.";
  const pe = dossier?.prochaine_etape;
  const etape = (pipeline?.steps || []).find((s) => s.code === code);
  const libelle = pe?.etape_pipeline_libelle || etape?.label;
  if (!libelle) return "";
  if (pe?.etape === "aucune") return `Où en est ce dossier : « ${libelle} ». ${(pe.motif || "Dossier terminé.").replace(/\.$/, "")}.`;   // même texte que la cellule « Dossier terminé » des grilles
  if (!pe || !pe.action) return `Où en est ce dossier : « ${libelle} ». Il n'y a pas d'étape à engager pour le moment.`;
  const raison = pe.etape === "attente" || !pe.motif ? "" : ` ${pe.motif.replace(/\.$/, "")}.`;
  return `Où en est ce dossier : « ${libelle} ». Prochaine étape : ${pe.action.charAt(0).toLowerCase()}${pe.action.slice(1)}.${raison}`;
}

/**
 * Étape du pipeline d'un dossier, SANS repli : un statut que ni les étapes ni le `legacy_mapping` du pipeline ne connaissent rend null,
 * au lieu de retomber sur « cree » comme `resolveStepCode` — invariant « statut non mappé ⇒ jamais un début de pipeline ».
 * Un dossier SANS statut du tout reste « cree » (il est neuf).
 */
export function etapeDuDossier(statut, dossier, pipeline) {
  if (!pipeline) return null;
  if (dossier?.statut_amo_sheet === "Abandonné" || dossier?.statut_amo === "Abandonné") return "abandonne";
  const src = ((dossier?.workflow_data || {}).tef || {}).pipeline_status || statut;
  if (!src) return "cree";
  if ((pipeline.steps || []).some((s) => s.code === src)) return src;
  return (pipeline.legacy_mapping || {})[src] || null;
}
